import { RateModelDto } from './ratemodeldto';
import { OwnLearningResourceRateTraductionDto } from './ownlearningresourceratetraductiondto';

export class LearningResourceFeeDto {
    idOwnLearningResourceRate?: number;
    chargeShipping?: boolean;
    active?: string;
    materialType?: string;
    rateModelDto?: RateModelDto;
    ownLearningResourceRateTraductionDto?: OwnLearningResourceRateTraductionDto[];

    constructor(data?: Partial<LearningResourceFeeDto>) {
        Object.assign(this, data);
    }
}

